import Vue from 'vue';
import Api from '@/config/api';

export default {
  state: {
    companyData: null,
    data: {},
    reg_email: '',
    // questions: {
    //   screening_intention: ['すぐの選考応募を希望、合致ポジションがあれば面接に進みたい',
    //     '選考応募を検討中、ポジション次第で応募を考えたい',
    //     '情報収拾のみ、中長期的に転職を検討したい'],
    //   job_history_record: ['すでに職務経歴書を作成している',
    //     '着手中であり、近日中に作成予定',
    //     'まだ作成していない'],
    // },
    serverErrors: {},
    formData: {
      slug: null,
      full_name: '',
      last_name: '',
      furigana: '',
      last_furigana: '',
      gender: null,
      email: '',
      email_confirmation: '',
      password: '',
      password_confirmation: '',
      birth_date: '',
      residence: '',
      final_education: '',
      graduation_school_name: '',
      graduation_department_name: '',
      year_of_graduation: '2013',
      recent_registered_company_name: '',
      // years_of_attendance: ''
      enrollment_period_from: '2013/',
      enrollment_period_to: '2013/',
      currently_enrolled: false,
      latest_occupation_main_title: '',
      latest_occupation_sub_title: '',
      employment_status: '',
      position: '',
      english_skills: '',
      last_year_income: '',
      number_of_experience_companies: '',
      // current_employment_situation: '在籍中',
      job_summary: '',
      screening_intention: '',
      // job_history_record: '',
      other_companies: [],
      // phone: '',
      resume_file_name: '',
      resume_selectedFile: '',
    },
  },
  getters: {
    getCompanyData(state) {
      // eslint-disable-next-line
      return state.companyData;
    },
    getServerErrors(state) {
      return state.serverErrors;
    },
    getFormData(state) {
      return state.formData;
    },
    getData(state) {
      return state.data;
    },
    getQuestions(state) {
      return state.questions;
    },
    getRegEmail(state) {
      return state.reg_email;
    },
    getRegCompany(state) {
      return state.company_name;
    },
  },
  mutations: {
    setCompanyData(state, data) {
      // eslint-disable-next-line
      state.companyData = data;
    },
    setServerErrors(state, data) {
      // eslint-disable-next-line
      state.serverErrors = data;
    },
    setFormData(state, data) {
      // eslint-disable-next-line
      state.formData = data;
    },
    setData(state, data) {
      // eslint-disable-next-line
      state.data = data;
    },
    setRegEmail(state, data) {
      // eslint-disable-next-line
      state.reg_email = data;
    },
    setRegCompany(state, data) {
      // eslint-disable-next-line
      state.company_name = data;
    },
    clear(state) {
      // eslint-disable-next-line
      state.formData = {
        slug: null,
        full_name: '',
        last_name: '',
        furigana: '',
        last_furigana: '',
        gender: '指定なし',
        email: '',
        password: '',
        password_confirmation: '',
        birth_date: '',
        residence: '',
        final_education: '',
        graduation_school_name: '',
        graduation_department_name: '',
        year_of_graduation: '2013',
        recent_registered_company_name: '',
        years_of_attendance: '',
        latest_occupation_main_title: '',
        latest_occupation_sub_title: '',
        employment_status: '',
        position: '',
        english_skills: '',
        last_year_income: '',
        number_of_experience_companies: '',
        current_employment_situation: '在籍中',
        job_summary: '',
        other_companies: [],
        companyData: null,
        // phone: '',
        resume_file_name: '',
        resume_selectedFile: '',
      };
      // eslint-disable-next-line
      state.serverErrors = {};
    },
  },
  actions: {
    async setData({ commit }, companyId) {
      const response = await Vue.axios({
        method: 'get',
        url: Api.url(`${Api.endpoints.GetSelectBoxValues}?companyId=${companyId}`),
      });
      commit('setData', response.data.data);
    },
    async setBloomData({ commit }, param) {
      const response = await Vue.axios({
        method: 'get',
        url: Api.url(`${Api.endpoints.GetSelectBoxValues}?isComp=${param}`),
      });
      commit('setData', response.data.data);
    },
    async setRegEmail({ commit }, email) {
      commit('setRegEmail', email);
    },
    async setRegCompany({ commit }, name) {
      commit('setRegCompany', name);
    },
    async checkCompany({ dispatch, commit }, slug) {
      try {
        const response = await Vue.axios({
          method: 'get',
          url: Api.url(`${Api.endpoints.CheckCompanyExists}/${slug}`),
        });
        commit('setCompanyData', response.data.data);
        await dispatch('setData', response.data.data.companyId);
        return response.data.data.companyFound;
      } catch (error) {
        return false;
      }
    },
    async checkMaintenance({ commit }) {
      try {
        const response = await Vue.axios({
          method: 'get',
          url: Api.url(`${Api.endpoints.checkMaintenance}`),
        });
        return response.data;
      } catch (error) {
        console.log(error.response);
        return true;
      }
    },
  },
};
